export default "__VITE_ASSET__zmwk$zZM__"